import styled from 'styled-components'

import { helpers } from 'styles'

export const Card = styled.div`
	padding: 16px 16px 24px;
	border-radius: 20px;
	border: 1px solid ${helpers.color.border};
`
